import type { ReactNode } from "react";

interface StepHeaderProps {
  title: ReactNode;
  subtitle: ReactNode;
}

export function StepHeader({ title, subtitle }: StepHeaderProps) {
  return (
    <>
      <h2 className="font-clash font-semibold text-2xl lg:text-5xl mb-4 leading-none">{title}</h2>
      <p className="text-ash-900 text-sm lg:text-base tracking-tight font-medium">{subtitle}</p>
    </>
  );
}
